export const DSGROUP_COMPANIES = [
  {
    id: "ds-foods-beverages",
    name: "DS Foods & Beverages — Catch · Pulse · Chingles",
    sector: "Branded Foods & Beverages",
    headcount: 6500,
    asbc_gap: 940800000,
    labour_cost: 6132000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/ds-foods-beverages-dsgroup-2026",
    signal: "red",
    urgency_reason: "Run to ₹20,000Cr by 2029 outpacing commercial & R&D talent build",
    functions: ["Brand Marketing", "Modern Trade & GT Sales", "R&D & Innovation", "Supply Chain & Manufacturing", "Digital Commerce", "Finance"],
    competitors: [
      { name: "DS Foods & Beverages",   score: 52, isTarget: true },
      { name: "ITC Foods",              score: 74 },
      { name: "Tata Consumer Products", score: 72 },
      { name: "Nestle India",           score: 82 },
      { name: "Britannia Industries",   score: 78 },
    ],
    velocity_headline: "ITC Foods visibly accelerating marketing and R&D bench across naturals and confectionery",
    leadership_scores: [7, 5, 7, 5, 5, 6, 6],
    readiness_score: 62,
    readiness_drivers: [
      "Catch + Pulse flagships generating strong consumer pull; constraint is commercial team density vs category leaders",
      "R&D pipeline funded but innovation velocity materially behind Nestle / ITC Foods",
      "Modern trade + D2C capability under-built relative to \u20b920k Cr ambition",
    ],
  },
  {
    id: "ds-mouth-fresheners",
    name: "DS Mouth Fresheners — Rajnigandha · Tansen · Mastaba",
    sector: "Branded Mouth Fresheners",
    headcount: 4800,
    asbc_gap: 672000000,
    labour_cost: 5548000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/ds-mouth-fresheners-dsgroup-2026",
    signal: "amber",
    urgency_reason: "Margin maturity phase \u2014 AI-enabled distribution and trade marketing optimisation is the upside",
    functions: ["Trade Marketing", "Distribution Optimisation", "Brand Stewardship", "Manufacturing & Procurement", "Category Innovation", "Finance"],
    competitors: [
      { name: "DS Mouth Fresheners",          score: 64, isTarget: true },
      { name: "Manikchand Group",             score: 66 },
      { name: "Godfrey Phillips India",       score: 70 },
      { name: "Kothari Products (Pan Parag)", score: 62 },
      { name: "Miraj Group",                  score: 58 },
    ],
    velocity_headline: "Godfrey Phillips deploying distribution analytics across paan-masala route network",
    leadership_scores: [7, 7, 7, 6, 6, 7, 6],
    readiness_score: 64,
    readiness_drivers: [
      "Rajnigandha + Tansen hold category leadership across premium and heritage tiers; distribution network among the deepest in Indian FMCG",
      "Upside is AI-enabled route optimisation and trade-marketing spend efficiency, not brand-building",
      "Margin structure healthy; working-capital and shelf-velocity are the next lever, not topline expansion",
    ],
  },
  {
    id: "ds-hospitality",
    name: "DS Hospitality \u2014 Heritage & Leisure Properties",
    sector: "Hotels & Hospitality",
    headcount: 1800,
    asbc_gap: 70080000,
    labour_cost: 438000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/ds-hospitality-dsgroup-2026",
    signal: "amber",
    urgency_reason: "6\u219212 property expansion (\u20b91,000Cr committed) outpacing GM and F&B leadership bench depth",
    functions: ["General Management Bench", "F&B Leadership", "Revenue Management", "Operations & Housekeeping", "Sales & MICE", "Finance"],
    competitors: [
      { name: "DS Hospitality",      score: 55, isTarget: true },
      { name: "Lemon Tree Hotels",   score: 72 },
      { name: "Chalet Hotels",       score: 74 },
      { name: "Royal Orchid Hotels", score: 62 },
      { name: "Sterling Holidays",   score: 58 },
    ],
    velocity_headline: "Lemon Tree executing asset-light expansion with tighter HQ-to-property ratios",
    leadership_scores: [6, 5, 6, 5, 5, 5, 5],
    readiness_score: 55,
    readiness_drivers: [
      "\u20b91,000Cr committed to 6\u219212 property doubling \u2014 capital is not the constraint",
      "GM bench and F&B leadership thin relative to the stated doubling timeline",
      "Revenue management and MICE capability need structural lift to compete on RevPAR with Lemon Tree / Chalet",
    ],
  },
  {
    id: "ds-agri-spices",
    name: "DS Agri & Spices \u2014 Catch Sourcing Backbone",
    sector: "Agri Sourcing & Spice Processing",
    headcount: 1200,
    asbc_gap: 50400000,
    labour_cost: 336000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/ds-agri-spices-dsgroup-2026",
    signal: "green",
    urgency_reason: "Vertically integrated sourcing backbone \u2014 the capability foundation the Group leans on; headroom is farmer-engagement tech",
    functions: ["Farmer Network Management", "Quality & Traceability", "Procurement & Hedging", "Spice Processing Operations", "Supply Chain", "Finance"],
    competitors: [
      { name: "DS Agri & Spices",   score: 72, isTarget: true },
      { name: "Olam Agri India",    score: 76 },
      { name: "Everest Spices",     score: 68 },
      { name: "MDH Spices",         score: 64 },
      { name: "Eastern Condiments", score: 62 },
    ],
    velocity_headline: "Olam Agri rolling out farmer-engagement mobile platform across 1M+ smallholder network",
    leadership_scores: [7, 7, 6, 7, 7, 6, 7],
    readiness_score: 72,
    readiness_drivers: [
      "Vertically integrated spice sourcing at category-leading scale; the backbone that Catch brand and wider Group F&B expansion depend on",
      "Quality and traceability infrastructure already strong; upside is farmer-engagement technology and predictive procurement",
      "Operational discipline high \u2014 organisation runs closer to process maturity than any other Group vertical",
    ],
  },
  {
    id: "ds-luxury-retail",
    name: "DS Luxury Retail \u2014 L'Opera \u00b7 Le Marche",
    sector: "Premium & Luxury Food Retail",
    headcount: 600,
    asbc_gap: 70080000,
    labour_cost: 438000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/ds-luxury-retail-dsgroup-2026",
    signal: "red",
    urgency_reason: "Category bet under-scaled relative to premium capital deployed \u2014 inflection point for scale decision",
    functions: ["Retail Operations", "Merchandising & Category Buy", "Brand & Experience", "Store Expansion", "Supply Chain", "Finance"],
    competitors: [
      { name: "DS Luxury Retail",            score: 42, isTarget: true },
      { name: "Foodhall (Future Retail)",    score: 58 },
      { name: "Nature's Basket (Spencer's)", score: 54 },
      { name: "Modern Bazaar",               score: 56 },
      { name: "Le Pain Quotidien India",     score: 62 },
    ],
    velocity_headline: "Le Pain Quotidien India scaling premium footprint with disciplined unit economics",
    leadership_scores: [5, 4, 6, 4, 5, 5, 4],
    readiness_score: 42,
    readiness_drivers: [
      "L'Opera + Le Marche hold premium positioning but footprint under-scaled relative to capital deployed",
      "Merchandising and retail operations capability thin vs specialty-retail benchmarks",
      "Category at an inflection \u2014 scale / reposition decision requires capability build ahead of direction call",
    ],
  },
  {
    id: "ds-tobacco-legacy",
    name: "DS Tobacco \u2014 Heritage Business",
    sector: "Tobacco \u2014 Managed Heritage Category",
    headcount: 1100,
    asbc_gap: 196000000,
    labour_cost: 1314000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/ds-tobacco-legacy-dsgroup-2026",
    signal: "amber",
    urgency_reason: "Managed runoff with structured talent redeployment into F&B and Hospitality",
    functions: ["Regulatory & Compliance", "Distribution Operations", "Institutional Talent Redeployment", "Manufacturing Rationalisation", "Finance"],
    competitors: [
      { name: "DS Tobacco \u2014 Heritage", score: 48, isTarget: true },
      { name: "ITC Cigarettes",             score: 80 },
      { name: "Godfrey Phillips India",     score: 72 },
      { name: "VST Industries",             score: 68 },
      { name: "Golden Tobacco",             score: 52 },
    ],
    velocity_headline: "ITC redeploying tobacco talent to FMCG at 2\u00d7 DS Group's pace",
    leadership_scores: [6, 7, 5, 5, 6, 5, 6],
    readiness_score: 54,
    readiness_drivers: [
      "Tobacco now <10% of Group revenue (from ~100% three decades ago) \u2014 category transformation already materially achieved",
      "Institutional workforce with 15+ year tenure; redeployment skill-bridge to F&B / Hospitality is the active capability gap",
      "Compliance posture strong; manufacturing rationalisation roadmap exists and is being executed",
    ],
  },
];
